import { inject, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { CustomSnackbarComponent } from '../../shared/components/custom-snackbar/custom-snackbar.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalDialogComponent } from '../../shared/components/modal-dialog/modal-dialog.component';
import { ModalDialogData } from '../models/model';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  private snackBar = inject(MatSnackBar);
  readonly dialog = inject(MatDialog);
  dialogRef!: MatDialogRef<unknown>;
  router = inject(Router);
  snackBarRef!: MatSnackBarRef<unknown>;

  showMessage(message: string, duration = 10000, closeOption = 'Close') {
    this.snackBar.open(message, closeOption, {
      duration: duration,
      horizontalPosition: 'right',
      verticalPosition: 'top',
    });

  }
  openSnackbar(data: {message: string, icon?: 'info' | 'success' | 'error' | 'warning', actionLabel?: string, duration?: number, action?: () => void}) {
    this.snackBarRef = this.snackBar.openFromComponent(CustomSnackbarComponent, {
      data: {
        message: data.message,
        icon: data.icon ?? 'error',
        actionLabel: data.actionLabel ?? 'OK',
        action: () => {
          // Handle action
          // action();
        },
      },
      duration: data.duration ?? 10000,
      verticalPosition: 'top',
      horizontalPosition: 'center',
    
      
    });
  }

  showToastMessageDialog(dialogData: ModalDialogData): void {
    this.dialogRef = this.dialog.open(ModalDialogComponent, {
      data: dialogData,
    });
  }

  showToastMessageDialogAndClose(dialogData: ModalDialogData): void {
    this.dialogRef = this.dialog.open(ModalDialogComponent, {
      data: dialogData,
    });

    this.dialogRef.afterClosed().subscribe(() => {
      this.router.navigate(['/']);

    });
  }

  closeDialog(): void {
    this.dialog.closeAll();
  }

}

